import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { Pages } from '../../../types/pages.enum';
import { ActivePageService } from '../../../services/active-page.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit, AfterViewInit {
  @Input()
  navItems!: Array<NavItems>;
  @Input()
  navButtons?: Array<TopLevelNavButton>;
  activePage?: Pages;
  @Input() partnerName = '';
  @Input() isSticky?: boolean;
  @Input() activeItem?: number;
  scrolledTo?: number;
  isScrolling = false;
  isStickyActive?: boolean;
  @Input() @HostBinding('class.home-nav-items') public isHome = false;
  @ViewChild('navBar') navElement!: ElementRef<HTMLElement>;
  offsetTop!: number;

  constructor(
    private activePageService: ActivePageService,
    private scroller: ViewportScroller,
  ) {
    this.activePageService.getObservable().subscribe((activePage) => {
      this.activePage = activePage;
    });
  }

  ngOnInit() {
    if (!this.navItems) {
      throw new Error('NavItems was not defined!');
    }
  }

  ngAfterViewInit(): void {
    this.offsetTop = this.navElement.nativeElement.offsetTop;
    this.scroller.setOffset([0, this.offsetTop + 10]);
  }

  @HostListener('window:scroll', ['$event']) onScroll() {
    if (!this.isSticky) {
      return;
    }

    if (!this.isScrolling && this.scrolledTo) {
      this.scrolledTo = undefined;
    }

    if (window.scrollY <= this.offsetTop) {
      this.isStickyActive = false;
      return;
    }

    this.isStickyActive = true;
  }

  isActivePage(activePages?: Array<Pages>) {
    if (!activePages) return true;

    return activePages.includes(this.activePage || ({} as Pages));
  }

  isUndefined(val: unknown | undefined) {
    return typeof val === 'undefined';
  }

  scrollToElement(element: string, i: number) {
    this.scroller.scrollToAnchor(element);
    this.isScrolling = true;
    this.scrolledTo = i;
    setTimeout(() => {
      this.isScrolling = false;
    }, 1000);
  }
}

export interface NavItems {
  activePage?: Pages;
  disable?: boolean;
  if?: boolean;
  link?: string;
  routerLink?: string;
  /** @description Use with routerLink */
  queryParams?: Params;
  text: string;
  scrollTo?: string;
}

export interface TopLevelNavButton {
  text?: string;
  if?: boolean;
  cssClass?: string;
  tooltipMessage?: string;
  activePage?: Pages;
  icon?: string;
  iconPlacement?: IconPlacement;
  activePages?: Array<Pages>;
  disabled?: boolean;
  message?: string;
  childButtons?: Array<ChildButton>;
  dataTestSelector?: string;
  ariaLabel?: string;

  // If the action function returns an observable the button will display loading until the observable completes.
  action(): Observable<unknown> | void;
}

export enum IconPlacement {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface ChildButton {
  text: string;
  cssClass?: string;
  dataTestSelector?: string;

  action(): Observable<unknown> | void;
}
